<template>
  <div class="settings-container">
    <!-- 左侧菜单 -->
    <div class="settings-sidebar">
      <a-card class="sidebar-card">
        <div class="sidebar-header">
          <a-icon type="setting" class="sidebar-icon" />
          <span class="sidebar-title">{{ translate('users.header.title19') }}</span>
        </div>
        <a-menu
          :selected-keys="[activeKey]"
          mode="inline"
          class="sidebar-menu"
          @select="handleMenuSelect"
        >
          <a-menu-item key="password">
            <a-icon type="lock" />
            <span>{{ translate('users.header.title1') }}</span>
          </a-menu-item>
          <a-menu-item key="security">
            <a-icon type="safety-certificate" />
            <span>{{ translate('users.header.title19') }}</span>
          </a-menu-item>
          <a-menu-item key="openapi">
            <a-icon type="api" />
            <span>{{ translate('users.header.title25') }}</span>
          </a-menu-item>
        </a-menu>
      </a-card>
    </div>

    <!-- 右侧内容 -->
    <div class="settings-content">
      <!-- 密码修改 -->
      <a-card v-if="activeKey === 'password'" class="content-card form-card">
        <div class="card-header">
          <a-icon type="lock" class="header-icon" />
          <div class="header-title">{{ translate('users.header.title1') }}</div>
        </div>
        
        <div class="form-section">
          <a-form
            :form="form"
            layout="vertical"
            class="password-form"
          >
            <a-form-item
              :label="translate('users.header.title2')"
              name="oldpasswd"
              :rules="[{ required: true, message: translate('users.header.title2') + '必填' }]"
            >
              <a-input-password v-model="formData.oldpasswd" :placeholder="translate('users.header.title6')" class="custom-input" />
            </a-form-item>
            <a-form-item
              :label="translate('users.header.title3')"
              name="newpasswd"
              :rules="[{ required: true, message: translate('users.header.title3') + '必填' }]"
            >
              <a-input-password v-model="formData.newpasswd" :placeholder="translate('users.header.title7')" class="custom-input" />
            </a-form-item>
            <a-form-item
              :label="translate('users.header.title4')"
              name="passwordcheck"
              :rules="[{ required: true, message: translate('users.header.title4') + '必填' }, { validator: this.rePassword, message: this.languageState.languageCode === 'zh' ? '两次密码不一致' : 'Two passwords do not match' }]"
            >
              <a-input-password v-model="formData.passwordcheck" :placeholder="translate('users.header.title8')" class="custom-input" />
            </a-form-item>
            <a-form-item class="form-actions">
              <a-button type="primary" @click="onSubmit" :loading="submitting" class="submit-btn">
                <a-icon type="save" />
                {{ translate('users.header.title1') }}
              </a-button>
              <a-button @click="onReset" class="reset-btn">
                <a-icon type="reload" />
                {{ translate('users.header.title5') }}
              </a-button>
            </a-form-item>
          </a-form>
        </div>
      </a-card>

      <!-- 安全设置 -->
      <a-card v-if="activeKey === 'security'" class="content-card form-card">
        <div class="card-header">
          <a-icon type="safety-certificate" class="header-icon security-icon" />
          <div class="header-title">{{ translate('users.header.title19') }}</div>
        </div>
        
        <div class="settings-list">
          <!-- 谷歌验证设置 -->
          <div class="setting-item">
            <div class="setting-info">
              <div class="setting-icon-wrapper google-icon">
                <a-icon type="google" />
              </div>
              <div class="setting-text">
                <div class="setting-title">{{ translate('users.header.title20') }}</div>
                <div class="setting-desc">{{ translate('users.header.title29') }}</div>
              </div>
            </div>
            <div class="setting-actions">
              <a-button 
                type="primary" 
                @click="handleChange(true)" 
                :disabled="shoubtn" 
                class="action-btn enable-btn"
                v-if="!shoubtn"
              >
                <a-icon type="plus-circle" />
                {{ translate('users.header.title20') }}
              </a-button>
              <a-button 
                @click="handleChange(false)" 
                :disabled="!shoubtn" 
                class="action-btn disable-btn"
                v-else
              >
                <a-icon type="close-circle" />
                {{ translate('users.header.title21') }}
              </a-button>
            </div>
          </div>
          
          <a-divider class="setting-divider" />
          
          <!-- 单点登录设置 -->
          <div class="setting-item">
            <div class="setting-info">
              <div class="setting-icon-wrapper sso-icon">
                <a-icon type="login" />
              </div>
              <div class="setting-text">
                <div class="setting-title">{{ translate('users.header.title22') }}</div>
                <div class="setting-desc">{{ translate('users.header.title30') }}</div>
              </div>
            </div>
            <div class="setting-actions">
              <a-button 
                type="primary" 
                @click="handleChangeSingle(true)" 
                :disabled="shouSingle" 
                class="action-btn enable-btn"
                v-if="!shouSingle"
              >
                <a-icon type="check-circle" />
                {{ translate('users.header.title23') }}
              </a-button>
              <a-button 
                @click="handleChangeSingle(false)" 
                :disabled="!shouSingle" 
                class="action-btn disable-btn"
                v-else
              >
                <a-icon type="minus-circle" />
                {{ translate('users.header.title24') }}
              </a-button>
            </div>
          </div>
        </div>
      </a-card>

      <!-- OpenAPI设置 -->
      <a-card v-if="activeKey === 'openapi'" class="content-card form-card">
        <div class="card-header">
          <a-icon type="api" class="header-icon api-icon" />
          <div class="header-title">{{ translate('users.header.title25') }}</div>
        </div>
        
        <div class="settings-list">
          <!-- 申请openkey -->
          <div class="setting-item" v-if="isReview === 2 || isReview === 0 || isReview === 3">
            <div class="setting-info">
              <div class="setting-icon-wrapper api-icon-wrapper">
                <a-icon type="key" />
              </div>
              <div class="setting-text">
                <div class="setting-title">{{ translate('users.header.title40') }}</div>
                <div class="setting-desc">{{ translate('users.header.title41') }}</div>
              </div>
            </div>
            <div class="setting-actions">
              <a-button 
                  type="primary" 
                  @click="handleOpenapi()" 
                  :disabled="isReview === 0" 
                  class="action-btn apply-btn"
                >
                  <a-icon type="send" />
                  {{ isReview === 3 ? translate('users.header.title46') : (isReview === 2 ? translate('users.header.title47') : translate('users.header.title48')) }}
                </a-button>
            </div>
          </div>
          
          <!-- 查看openkey -->
          <div class="setting-item openkey-item" v-if="isReview === 1">
            <div class="setting-info">
              <div class="setting-icon-wrapper api-icon-wrapper">
                <a-icon type="lock" />
              </div>
              <div class="setting-text">
                <div class="setting-title">OpenAPI Key</div>
              </div>
            </div>
            <div class="openkey-row">
              <div class="openkey-value">{{ openkey }}</div>
              <div class="openkey-actions">
                <a-button type="text" @click="handleOpenkey(2)" v-if="!showbrowse" class="action-btn text-btn">
                  <a-icon type="eye" />
                  {{ translate('users.header.title31') }}
                </a-button>
                <a-button type="text" @click="handleOpenkey(1)" v-else class="action-btn text-btn">
                  <a-icon type="eye-invisible" />
                  {{ translate('users.header.title32') }}
                </a-button>
                <a-button type="text" @click="handleResetOpenkey" class="action-btn danger-btn">
                  <a-icon type="reload" />
                  {{ translate('users.header.title5') }}
                </a-button>
              </div>
            </div>
          </div>
        </div>
      </a-card>
    </div>

    <!-- 谷歌验证弹窗 -->
    <a-modal
      :visible="visible"
      :title="translate('users.header.title20')"
      @ok="onConfirm"
      @cancel="handleCancel"
      @update:visible="visible = $event"
      :okText="translate('users.header.title43')"
      :cancelText="translate('users.header.title5')"
      class="auth-modal"
    >
      <div class="modal-content">
        <div class="modal-header">
          <a-icon type="google" class="modal-icon" />
          <span>{{ translate('users.header.title33') }}</span>
        </div>
        <div v-if="showQrCode" class="qrcode-section">
          <vue-qr :text="imgurl" :size="180" class="qr-code" />
        </div>
        <div class="authcode-section">
          <a-form-item :label="translate('users.header.title34')">
            <a-input v-model="authcodein" :placeholder="translate('users.header.title35')" class="custom-input" />
          </a-form-item>
        </div>
      </div>
    </a-modal>

    <!-- 关闭谷歌验证弹窗 -->
    <a-modal
      :visible="visibleClose"
      :title="translate('users.header.title21')"
      @ok="onConfirmGoole"
      @cancel="handleCancel"
      @update:visible="visibleClose = $event"
      :okText="translate('users.header.title44')"
      :cancelText="translate('users.header.title5')"
      class="auth-modal"
    >
      <div class="modal-content">
        <div class="modal-header">
          <a-icon type="warning" class="modal-icon warning" />
          <span>{{ translate('users.header.title36') }}</span>
        </div>
        <a-form-item :label="translate('users.header.title28')">
          <a-input-password v-model="password" placeholder="请输入密码" class="custom-input" />
        </a-form-item>
        <a-form-item :label="translate('users.header.title26')">
          <a-input v-model="authcodein" placeholder="请输入验证码" class="custom-input" />
        </a-form-item>
      </div>
    </a-modal>

    <!-- 重置openkey弹窗 -->
    <a-modal
      :visible="visibleModal"
      :title="translate('users.header.title42')"
      @ok="handleResetOpenkeyConfirm"
      @cancel="handleCancel"
      @update:visible="visibleModal = $event"
      :okText="translate('users.header.title45')"
      :cancelText="translate('users.header.title5')"
      class="auth-modal"
    >
      <div class="modal-content">
        <div class="modal-header">
          <a-icon type="key" class="modal-icon" />
          <span>{{ translate('users.header.title37') }}</span>
        </div>
        <a-form-item :label="translate('users.header.title38')">
          <a-input v-model="oldopenkey" :placeholder="translate('users.header.title39')" class="custom-input" />
        </a-form-item>
      </div>
    </a-modal>
  </div>
</template>

<script>
import vueQr from 'vue-qr';

export default {
  name: 'UserSettings',
  components: {
    vueQr
  },
  inject: ['languageState'],
  data() {
    return {
      activeKey: 'password',
      submitting: false,
      form: null,
      formData: {
        oldpasswd: '',
        newpasswd: '',
        passwordcheck: ''
      },
      qrCodeUrl: '',
      imageUrl: '',
      visible: false,
      visibleClose: false,
      visibleModal: false,
      imgurl: '',
      authcodein: '',
      password: '',
      shoubtn: false,
      shouSingle: false,
      userdata: {},
      isReview: -1,
      openkey: '*********',
      showbrowse: false,
      oldopenkey: '',
      showQrCode: false
    };
  },
  mounted() {
    this.getGooleAuthInfo();
    this.getUserInfo();
    this.checkApplyOpenkey();
  },
  methods: {
    // 获取谷歌验证信息
    getGooleAuthInfo() {
      this.$request.post('/gooleauth/getGoogleAuth').then((res) => {
        if(res.data.data){
          if(res.data.data.status == 1){
            this.shoubtn = true;
          } else {
            this.shoubtn = false;
          }
        }else{
          this.shoubtn = false;
        }
      })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
        });
    },
    
    // 获取用户信息
    getUserInfo() {
      this.$request.get('/ums/user/info').then((res) => {
        if (res.data.data) {
          this.userdata = res.data.data;
          this.shouSingle = res.data.data.isSingle === 0 ? false : true;
        }
      })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {})
    },
    
    // 查询当前用户是否申请了openkey
    checkApplyOpenkey() {
      this.$request.get('/ums/user/checkApplyOpenkey').then((res) => {
        if(res.data.data){
          if(res.data.data.isreview === 0){
            this.isReview = 0;
          } else if(res.data.data.isreview === 1){
            this.isReview = 1;
          } else if(res.data.data.isreview === 2){
            this.isReview = 2;
          } else{
            this.isReview = 3;
          }
        }
      })
    },
    
    // 申请openapi
    handleOpenapi() {
      this.$confirm({
        title: this.translate('users.header.title46'),
        content: this.languageState.languageCode === 'zh' ? '申请openkey后,可以在开放平台调用该接口' : 'After applying for openkey, you can call this interface on the open platform',
        onOk: () => {
          this.$request.post('/ums/user/applyOpenkey', {}).then((res) => {
            if (res.data.code === 200) {
              this.$message.success(this.languageState.languageCode === 'zh' ? '申请成功,请等待审核' : 'Application successful, please wait for review');
              this.checkApplyOpenkey();
            }
          })
        }
      });
    },
    
    // 查看openkey
    handleOpenkey(type) {
      if(type === 2){
          this.$request.get('/ums/user/getOpenkey').then((res) => {
            if(res.data.data){
              this.openkey = res.data.data.key;
              this.showbrowse = true;
            }else{
              this.$message.error(this.languageState.languageCode === 'zh' ? '获取失败' : 'Failed to get');
              this.showbrowse = false;
            }
          })
        }else{
          this.showbrowse = false;
          this.openkey = "*********";
        }
    },
    
    // 重置openkey
    handleResetOpenkey() {
      this.visibleModal = true;
    },
    
    // 重置openkey确认
    handleResetOpenkeyConfirm() {
      if(this.oldopenkey === ""){
        this.$message.error(this.translate('users.header.title39'));
        return;
      }
      this.$request.get('/ums/user/resetOpenkey?oldkey='+this.oldopenkey).then((res) => {
        if(res.data.code === 200){
          this.$message.success(this.languageState.languageCode === 'zh' ? '重置成功' : 'Reset successful');
          this.visibleModal = false;
          this.oldopenkey = "";
          this.openkey = "*********";
          this.showbrowse = false;
        }else{
          this.$message.error(this.languageState.languageCode === 'zh' ? '重置失败' : 'Reset failed');
        }
      })
    },
    
    // 处理菜单选择
    handleMenuSelect({ key }) {
      this.activeKey = key;
    },
    
    // 处理谷歌验证开关
    handleChange(e) {
      this.authcodein = "";
      this.password = "";
      if(e){
        this.getGooleAuthCode();
        this.showQrCode = true;
        this.visible = true;
      }else{
        this.showQrCode = false;
        this.visibleClose = true;
      }
    },
    
    // 获取谷歌验证二维码
    getGooleAuthCode(){
      this.$request.post('/gooleauth/startGoogleAuthenticator').then((res) => {
        this.imgurl = res.data;
      })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
        });
    },
    
    // 确认谷歌验证
    onConfirm() {
      this.$request.post('/gooleauth/openGoogleAuthenticator',{
        code:this.authcodein
      }).then((res) => {
        if(res.data.data == 1){
          window.localStorage.clear();
          this.$router.push(`/login?redirect=${this.$route.fullPath}`);
        }else{
          this.$message.error('验证失败');
          this.visible = false;
        }
      })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
        });
    },
    
    // 确认关闭谷歌验证
    onConfirmGoole() {
      this.$request.post('/gooleauth/closeGoogleAuthenticator',{
        code:this.authcodein,
        password:this.password,
      }).then((res) => {
        console.log(res);
        if(res.data.data == 1){
          window.localStorage.clear();
          this.$router.push(`/login?redirect=${this.$route.fullPath}`);
        }else{
          this.$message.error('验证失败');
          this.visibleClose = false;
        }
      })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
        });
    },
    
    // 取消弹窗
    handleCancel() {
      this.visible = false;
      this.visibleClose = false;
      this.visibleModal = false;
    },
    
    // 更改密码
    onSubmit() {
      this.submitting = true;
      this.$request
        .post('/ums/user/save', this.formData)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success('修改成功');
            window.localStorage.clear();
            this.$router.push(`/login?redirect=${this.$route.fullPath}`);
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    
    // 重置表单
    onReset() {
      this.formData.oldpasswd = '';
      this.formData.newpasswd = '';
      this.formData.passwordcheck = '';
    },
    
    // 密码确认验证方法
    rePassword(rule, value, callback) {
      if (!value || this.formData.newpasswd === value) {
        callback();
      } else {
        callback(new Error('两次密码不一致'));
      }
    },
    
    // 单点登录开关
    handleChangeSingle(e) {
      if(e){
        this.$request.post('/ums/updateIsSingle',{
          isSingle:1
        }).then((res) => {
          if(res.data.code == 200){
            window.localStorage.clear();
            this.$router.push(`/login?redirect=${this.$route.fullPath}`);
          }else{
            this.$message.error('开启失败');
          }
        })
      }else{
        this.$request.post('/ums/updateIsSingle',{
          isSingle:0
        }).then((res) => {
          if(res.data.code == 200){
            window.localStorage.clear();
            this.$router.push(`/login?redirect=${this.$route.fullPath}`);
          }else{
            this.$message.error('开启失败');
          }
        })
      }
    },
    
    // 国际化翻译
    translate(key) {
      const lang = this.languageState ? this.languageState.languageCode : 'zh';
      const translations = {
        'users.header.title1': lang === 'zh' ? '修改密码' : 'Change Password',
        'users.header.title2': lang === 'zh' ? '旧密码' : 'Old Password',
        'users.header.title3': lang === 'zh' ? '新密码' : 'New Password',
        'users.header.title4': lang === 'zh' ? '确认密码' : 'Confirm Password',
        'users.header.title5': lang === 'zh' ? '重置' : 'Reset',
        'users.header.title6': lang === 'zh' ? '请输入旧密码' : 'Please enter old password',
        'users.header.title7': lang === 'zh' ? '请输入新密码' : 'Please enter new password',
        'users.header.title8': lang === 'zh' ? '请再次输入密码' : 'Please re-enter password',
        'users.header.title19': lang === 'zh' ? '安全设置' : 'Security Settings',
        'users.header.title20': lang === 'zh' ? '开启谷歌验证' : 'Enable Google Verification',
        'users.header.title21': lang === 'zh' ? '关闭谷歌验证' : 'Disable Google Verification',
        'users.header.title22': lang === 'zh' ? '单点登录' : 'Single Sign On',
        'users.header.title23': lang === 'zh' ? '开启单点登录' : 'Enable Single Sign On',
        'users.header.title24': lang === 'zh' ? '关闭单点登录' : 'Disable Single Sign On',
        'users.header.title25': lang === 'zh' ? 'OpenAPI设置' : 'OpenAPI Settings',
        'users.header.title26': lang === 'zh' ? '验证码' : 'Verification Code',
        'users.header.title27': lang === 'zh' ? '关闭谷歌验证' : 'Disable Google Verification',
        'users.header.title28': lang === 'zh' ? '密码' : 'Password',
        'users.header.title29': lang === 'zh' ? '绑定Google Authenticator增强账户安全性' : 'Bind Google Authenticator to enhance account security',
        'users.header.title30': lang === 'zh' ? '开启单点登录功能，实现一次登录多处使用' : 'Enable single sign-on function to achieve one login for multiple uses',
        'users.header.title31': lang === 'zh' ? '显示' : 'Show',
        'users.header.title32': lang === 'zh' ? '隐藏' : 'Hide',
        'users.header.title33': lang === 'zh' ? '扫描二维码绑定Google Authenticator' : 'Scan QR code to bind Google Authenticator',
        'users.header.title34': lang === 'zh' ? '请输入验证码' : 'Please enter verification code',
        'users.header.title35': lang === 'zh' ? '请输入6位验证码' : 'Please enter 6-digit verification code',
        'users.header.title36': lang === 'zh' ? '关闭谷歌验证需要验证身份' : 'Disabling Google verification requires identity verification',
        'users.header.title37': lang === 'zh' ? '请输入原OpenAPI Key进行验证' : 'Please enter original OpenAPI Key for verification',
        'users.header.title38': lang === 'zh' ? '原OpenAPI Key' : 'Original OpenAPI Key',
        'users.header.title39': lang === 'zh' ? '请输入原本的openkey' : 'Please enter original openkey',
        'users.header.title40': lang === 'zh' ? '申请OpenAPI Key' : 'Apply for OpenAPI Key',
        'users.header.title41': lang === 'zh' ? '获取API访问权限，集成第三方应用' : 'Get API access to integrate third-party applications',
        'users.header.title42': lang === 'zh' ? '重置OpenAPI Key' : 'Reset OpenAPI Key',
        'users.header.title43': lang === 'zh' ? '确认绑定' : 'Confirm Binding',
        'users.header.title44': lang === 'zh' ? '确认关闭' : 'Confirm Closure',
        'users.header.title45': lang === 'zh' ? '确认重置' : 'Confirm Reset',
        'users.header.title46': lang === 'zh' ? '申请openkey' : 'Apply for openkey',
        'users.header.title47': lang === 'zh' ? '重新申请' : 'Re-apply',
        'users.header.title48': lang === 'zh' ? '审核中' : 'Under Review'
      };
      return translations[key] || key;
    }
  }
};
</script>

<style scoped lang="less">
@primary-color: #1890ff;
@primary-hover: #40a9ff;
@primary-active: #69c0ff;
@success-color: #52c41a;
@warning-color: #faad14;
@error-color: #f5222d;
@text-primary: #262626;
@text-secondary: #595959;
@text-tertiary: #8c8c8c;
@border-color: #f0f0f0;
@bg-primary: #ffffff;
@bg-secondary: #fafafa;

.settings-container {
  display: flex;
  gap: 24px;
  min-height: calc(100vh - 64px);
  padding: 0;
}

/* 左侧菜单 */
.settings-sidebar {
  width: 280px;
  flex-shrink: 0;
}

.sidebar-card {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  background: @bg-primary;
  border: 1px solid @border-color;
  overflow: hidden;
  
  :deep(.ant-card-body) {
    padding: 0;
  }
}

.sidebar-header {
  display: flex;
  align-items: center;
  padding: 20px 24px;
  // background: linear-gradient(135deg, @primary-color 0%, #096dd9 100%);
  // color: white;
  margin: 0;
  
  .sidebar-icon {
    font-size: 24px;
    margin-right: 12px;
  }
  
  .sidebar-title {
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.5px;
  }
}

.sidebar-menu {
  border-right: none;
  
  .ant-menu-item {
    padding: 14px 24px;
    font-size: 14px;
    font-weight: 500;
    margin: 4px 8px;
    border-radius: 8px;
    height: auto;
    line-height: 1.5;
    
    &:hover {
      background: linear-gradient(135deg, #f0f5ff 0%, #e6f7ff 100%);
      color: @primary-color;
    }
    
    &.ant-menu-item-selected {
      background: linear-gradient(135deg, @primary-color 0%, #096dd9 100%);
      color: white;
      
      &::after {
        display: none;
      }
    }
  }
}

/* 右侧内容 */
.settings-content {
  flex: 1;
  overflow-y: auto;
}

.content-card {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  background: @bg-primary;
  border: 1px solid @border-color;
  
  :deep(.ant-card-body) {
    padding: 28px;
  }
}

/* 卡片头部 */
.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 28px;
  padding-bottom: 20px;
  border-bottom: 2px solid @border-color;
  
  .header-icon {
    font-size: 26px;
    margin-right: 16px;
    color: @primary-color;
  }
  
  .header-title {
    font-size: 18px;
    font-weight: 600;
    color: @text-primary;
  }
}

/* 表单样式 */
.form-section {
  max-width: 480px;
}

.password-form {
  :deep(.ant-form-item-label) {
    label {
      font-size: 14px;
      font-weight: 500;
      color: @text-primary;
    }
  }
}

.custom-input {
  border-radius: 8px;
  height: 44px;
  
  &:hover, &:focus {
    border-color: @primary-color;
  }
}

.form-actions {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid @border-color;
}

.submit-btn {
  height: 44px;
  font-size: 14px;
  font-weight: 500;
  padding: 0 28px;
  border-radius: 8px;
  background: linear-gradient(135deg, @primary-color 0%, #096dd9 100%);
  border: none;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
  transition: all 0.3s ease;
  margin-right: 12px;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(24, 144, 255, 0.4);
  }
}

.reset-btn {
  height: 44px;
  font-size: 14px;
  font-weight: 500;
  padding: 0 28px;
  border-radius: 8px;
  border: 1px solid @border-color;
  transition: all 0.3s ease;
  
  &:hover {
    border-color: @primary-color;
    color: @primary-color;
  }
}

/* 设置列表 */
.settings-list {
  .setting-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0;
  }
  
  .setting-info {
    display: flex;
    align-items: center;
    flex: 1;
  }
  
  .setting-icon-wrapper {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    font-size: 22px;
    
    &.google-icon {
      background: linear-gradient(135deg, #f0f5ff 0%, #e6f7ff 100%);
      color: @primary-color;
    }
    
    &.sso-icon {
      background: linear-gradient(135deg, #f6ffed 0%, #d9f7be 100%);
      color: @success-color;
    }
    
    &.api-icon-wrapper {
      background: linear-gradient(135deg, #fff7e6 0%, #ffd591 100%);
      color: @warning-color;
    }
  }
  
  .setting-text {
    flex: 1;
    
    .setting-title {
      font-size: 15px;
      font-weight: 600;
      color: @text-primary;
      margin-bottom: 4px;
    }
    
    .setting-desc {
      font-size: 13px;
      color: @text-tertiary;
    }
  }
  
  .setting-actions {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .action-btn {
    height: 36px;
    font-size: 13px;
    font-weight: 500;
    border-radius: 6px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    gap: 6px;
    
    &.enable-btn {
      background: linear-gradient(135deg, @primary-color 0%, #096dd9 100%);
      border: none;
      color: white;
      
      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
      }
    }
    
    &.disable-btn {
      background: @bg-primary;
      border: 1px solid @border-color;
      color: @text-secondary;
      
      &:hover {
        border-color: @error-color;
        color: @error-color;
      }
    }
    
    &.apply-btn {
      background: linear-gradient(135deg, @warning-color 0%, #d48806 100%);
      border: none;
      color: white;
      
      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(250, 173, 20, 0.3);
      }
    }
    
    &.text-btn {
      padding: 4px 8px;
      height: auto;
      
      &:hover {
        background: @bg-secondary;
      }
    }
    
    &.danger-btn {
      padding: 4px 8px;
      height: auto;
      color: @error-color;
      
      &:hover {
        background: #fff1f0;
      }
    }
  }
  
  .setting-divider {
    margin: 0;
    border-color: @border-color;
  }
}

/* OpenAPI Key行样式 */
.openkey-item {
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  
  .setting-info {
    width: 100%;
  }
}

.openkey-row {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 16px;
}

.openkey-value {
  font-family: 'Courier New', monospace;
  color: @text-secondary;
  background: @bg-secondary;
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 13px;
  flex-shrink: 0;
  min-width: 200px;
}

.openkey-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 模态框样式 */
.auth-modal {
  :deep(.ant-modal-header) {
    padding: 20px 24px;
    border-bottom: 1px solid @border-color;
    
    .ant-modal-title {
      font-size: 16px;
      font-weight: 600;
    }
  }
  
  :deep(.ant-modal-body) {
    padding: 24px;
  }
  
  :deep(.ant-modal-footer) {
    padding: 16px 24px;
    border-top: 1px solid @border-color;
  }
}

.modal-content {
  .modal-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
    font-size: 14px;
    color: @text-primary;
    
    .modal-icon {
      font-size: 20px;
      color: @primary-color;
      
      &.warning {
        color: @warning-color;
      }
    }
  }
  
  .qrcode-section {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    
    .qr-code {
      padding: 16px;
      background: white;
      border-radius: 12px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }
  }
  
  .authcode-section {
    :deep(.ant-form-item-label) {
      label {
        font-weight: 500;
      }
    }
  }
}

/* 响应式设计 */
@media (max-width: 992px) {
  .settings-container {
    flex-direction: column;
    gap: 16px;
  }
  
  .settings-sidebar {
    width: 100%;
  }
  
  .settings-list {
    .setting-item {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
    }
    
    .setting-actions {
      width: 100%;
      justify-content: flex-start;
    }
  }
  
  .openkey-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .openkey-value {
    width: 100%;
  }
  
  .openkey-actions {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .content-card :deep(.ant-card-body) {
    padding: 20px;
  }
  
  .card-header {
    margin-bottom: 20px;
    padding-bottom: 16px;
    
    .header-icon {
      font-size: 22px;
    }
    
    .header-title {
      font-size: 16px;
    }
  }
  
  .submit-btn,
  .reset-btn {
    height: 40px;
    padding: 0 20px;
    font-size: 13px;
  }
  
  .form-actions {
    display: flex;
    flex-direction: column;
    gap: 12px;
    
    button {
      width: 100%;
    }
  }
}
</style>
